module.exports = __webpack_public_path__ + "static/img/deposit_bottom_bg.8b04f088.png";